import { useHistory } from 'react-router-dom'
import * as Redux from 'redux'
import {
    ICommonQuery,
    ITableHeaders,
    IPageHeaderActions,
} from '@Models/common.model'
import { connect } from 'react-redux'
import { useEffect, useState, createRef } from 'react'
import TableInvoice from '@Pages/Client/my-account/statement/TableInvoice'
import TableTotal from '@Pages/Client/my-account/statement/TableTotal'
import ClientMyAccountActions from '@ClientActions/my-account.action'
import { MInvoice } from '@Models/client/my-account.model'
import ReactToPrint from 'react-to-print'
import moment from 'moment'
import { APIServices } from '@Services/api.service'

import BaseButton from '@Components/Form/BaseButton/BaseButton'
import PageHeader from '@Components/Pages/PageHeader/PageHeader'
import AccountInfo from '../AccountInfo'

// dummy data
const headerActions: IPageHeaderActions[] = [
    {
        name: 'Receipt',
        value: '/my-account/receipt',
    },
]

const headers: ITableHeaders[] = [
    {
        name: 'Serial',
        key: 'serial',
    },
    {
        name: 'Period',
        key: 'period',
    },
    {
        name: 'Description',
        key: 'description',
    },
    {
        name: 'Date',
        key: 'date',
    },
    {
        name: 'Fee',
        key: 'fee',
    },
    {
        name: 'Qty',
        key: 'qty',
    },
    {
        name: 'Total',
        key: 'total',
    },
]

// models section
interface IStatement {
    // redux
    getInvoices?: (params?: ICommonQuery) => void
    invoices?: MInvoice[]
}

const Statement = (props: IStatement) => {
    // core section
    const { getInvoices, invoices } = props
    const history = useHistory()
    const [refElements, setRefElements] = useState<any>([])
    const [disabledIndex, setDisabledIndex] = useState(null)

    // hooks section
    useEffect(() => {
        if (getInvoices) getInvoices()
        return () => {
            APIServices.axiosCancelToken()
        }
    }, [])

    /**
     * create Ref when invoices changed
     */
    useEffect(() => {
        setRefElements((refE: any) =>
            Array(invoices?.length)
                .fill(null)
                .map((_, i) => refE[i] || createRef())
        )
        return () => {
            setRefElements([])
        }
    }, [invoices?.length])

    // functions section
    /**
     * handle header component action clicked
     * @param action name from header component
     */
    const onHandleActions = (action: string) => {
        history.push(action)
    }

    /**
     * element
     * @returns button print
     */
    const handlePrint = (index: number) => {
        return (
            <BaseButton
                className="variant-red btn-lg-width"
                disabled={index === disabledIndex}
                isLoading={index === disabledIndex}
            >
                Print
            </BaseButton>
        )
    }

    // main section
    return (
        <div className="page-account-statement">
            <PageHeader
                title="My Account"
                actions={headerActions}
                getActions={(e: any) => onHandleActions(e)}
            />
            <p className="page-title">Statement</p>
            {invoices?.map((invoice: MInvoice, index: any) => {
                return (
                    <div
                        className="page-white-card p-4 mb-4"
                        key={`${invoice?.code}_invoice_key_${+index}`}
                    >
                        <div ref={refElements[index]}>
                            <div className="d-flex justify-content-between">
                                <AccountInfo user={invoice?.user} />
                                <p className="black-text">
                                    Invoice #: {invoice?.code}
                                </p>
                            </div>
                            <TableInvoice
                                headers={headers}
                                data={invoice?.items}
                            />
                            <TableTotal data={invoice?.payment} />
                        </div>
                        <div className="text-right">
                            <ReactToPrint
                                documentTitle={`${moment().format(
                                    'DD-MM-YYYY'
                                )}-${invoice?.code}`}
                                bodyClass="pdf-print-class"
                                trigger={() => handlePrint(index)}
                                content={() => refElements?.[index]?.current}
                                onAfterPrint={() => {
                                    setDisabledIndex(null)
                                }}
                                onBeforePrint={() => {
                                    setDisabledIndex(index)
                                }}
                            />
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

// store section
const mapStateToProps = (store: any) => {
    const { firearms, accessories } = store?.client
    const { invoices } = store?.client?.myAccount
    return {
        firearms: firearms?.firearmData,
        accessories: accessories?.accessoriesData,
        invoices,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { getInvoices } = ClientMyAccountActions
    return {
        getInvoices: (params?: ICommonQuery) =>
            dispatch(getInvoices(params) as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Statement)
